var SessionCloseReason = {
    CONNECTION_LOST : 0,
    IO_EXCEPTION : 1,
    CLIENT_UNRESPONSIVE : 2,
    MESSAGE_QUEUE_LIMIT_REACHED : 3,
    CLOSED_BY_CLIENT : 4,
    MESSAGE_TOO_LARGE : 5,
    INTERNAL_ERROR : 6,
    INVALID_INBOUND_MESSAGE : 7,
    ABORT : 8,
    LOST_MESSAGES : 9,
    SERVER_CLOSING : 10,
    CLOSED_BY_CONTROLLER : 11
};

module.exports = SessionCloseReason;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/session-close-reason.js
// module id = 1033
// module chunks = 1